import { render } from "./SkillGraph.vue?vue&type=template&id=499adc0a&scoped=true"
import script from "./SkillGraph.vue?vue&type=script&lang=js"
export * from "./SkillGraph.vue?vue&type=script&lang=js"

import "./SkillGraph.vue?vue&type=style&index=0&id=499adc0a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499adc0a"]])

export default __exports__